{
  "errors": {
    "messages": {
      "blank": "no puede estar vacío",
      "required": "es obligatorio",
      "mustExist": "es obligatorio",
      "invalid": "no es válido",
      "taken": "ya existe",
      "notANumber": "no es un número",
      "tooShort": "es demasiado corto",
      "tooLong": "es demasiado largo",
      "greaterThan": "debe ser mayor",
      "lessThan": "debe ser menor"
    },
    "fields": {
      "general_info_entries": "Entrada",
      "general_info_entry_additional_retentions": "Retención adicional",
      "report_entries": "Entrada",
      "report_entry_days": "Día",
      "report_entry_day_events": "Evento",
      "payroll_entries": "Entrada",
      "payroll_entry_days": "Día",
      "payroll_entry_day_additional_retentions": "Retención adicional",
      "order_references": "Referencia",
      "order_print_inks": "Tinta",
      "order_mix_entries": "Mezcla",
      "extrusion_orders": "Orden",
      "employee": "Empleado"
    }
  },
  "common": {
    "save": "Guardar",
    "saveAndContinue": "Guardar y Continuar",
    "saving": "Guardando…",
    "cancel": "Cancelar",
    "clear": "Limpiar",
    "delete": "Eliminar",
    "deleting": "Eliminando…",
    "edit": "Editar",
    "new": "Nuevo",
    "duplicate": "Duplicar",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "downloadExcel": "Descargar Excel",
    "downloadError": "No se pudo generar el archivo. Inténtelo de nuevo.",
    "loadError": "No se pudieron cargar los datos. Inténtelo de nuevo.",
    "excel": "Excel",
    "search": "Buscar…",
    "reload": "Recargar",
    "back": "Atrás",
    "home": "Inicio",
    "add": "Agregar",
    "noData": "No se encontraron datos.",
    "name": "Nombre",
    "date": "Fecha",
    "updatedAt": "Actualizado",
    "id": "ID",
    "deleteCannotUndo": "Esta acción no se puede deshacer.",
    "loading": "Cargando…",
    "export": "Exportar {{count}} / {{total}}",
    "startDate": "Fecha de Inicio",
    "endDate": "Fecha de Fin",
    "noDataRange": "No hay datos para el rango seleccionado.",
    "reports": "Reportes",
    "total": "Total",
    "employee": "Empleado",
    "generalInfo": "Info General",
    "reportDate": "Fecha del Reporte",
    "remove": "Eliminar",
    "removeEntry": "Eliminar entrada",
    "addEntry": "Agregar Entrada",
    "entries": "Entradas",
    "noEntries": "No hay entradas aún.",
    "days": "Días",
    "addDay": "Agregar Día"
  },
  "nav": {
    "signedInAs": "Conectado como",
    "oldDashboard": "Panel Antiguo",
    "logout": "Cerrar Sesión",
    "lightMode": "Modo claro",
    "darkMode": "Modo oscuro",
    "switchToSpanish": "Español",
    "switchToEnglish": "English"
  },
  "home": {
    "title": "Inicio",
    "subtitle": "Selecciona un módulo para comenzar.",
    "humanResources": "Recursos Humanos",
    "production": "Producción",
    "system": "Sistema",
    "isNew": "Nuevo"
  },
  "auth": {
    "login": "Iniciar Sesión",
    "selectSignIn": "Selecciona cómo deseas iniciar sesión",
    "admCloud": "ADM Cloud",
    "admCloudDesc": "Inicia sesión con tus credenciales de ADM Cloud.",
    "system": "Sistema",
    "systemDesc": "Inicia sesión con tus credenciales del sistema.",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "signIn": "Iniciar sesión",
    "signingIn": "Iniciando sesión...",
    "comingSoon": "Próximamente",
    "or": "O"
  },
  "modules": {
    "employees": "Empleados",
    "employeesDesc": "Gestionar empleados",
    "generalInfo": "Info General",
    "generalInfoDesc": "Gestionar pagos y retenciones de empleados",
    "weeklyReport": "Reporte Semanal",
    "weeklyReportDesc": "Gestionar reportes semanales",
    "payrolls": "Nóminas",
    "payrollsDesc": "Gestionar nóminas de empleados",
    "orders": "Órdenes",
    "ordersDesc": "Gestionar órdenes de producción",
    "extrusion": "Extrusión",
    "extrusionDesc": "Gestionar programa de producción de extrusión",
    "exports": "Exportaciones",
    "exportsDesc": "Reporte de exportaciones agrupado por cliente con sincronización de órdenes.",
    "history": "Historial",
    "historyDesc": "Consultar todos los cambios registrados en el sistema"
  },
  "employees": {
    "title": "Empleados",
    "new": "Nuevo Empleado",
    "noData": "No se encontraron empleados.",
    "fpcId": "ID FPC",
    "fullName": "Nombre",
    "group": "Grupo",
    "department": "Departamento",
    "position": "Posición",
    "joinDate": "Fecha de Ingreso",
    "deleteTitle": "Eliminar Empleado",
    "deleteText": "¿Estás seguro de que deseas eliminar al empleado {{name}}? Esta acción no se puede deshacer.",
    "duplicateTitle": "Duplicar Empleado",
    "duplicateText": "¿Duplicar a {{name}}? Se creará un nuevo registro con los mismos datos.",
    "duplicating": "Duplicando...",
    "lastName": "Apellido",
    "groups": {
      "none": "Ninguno",
      "administrative": "Administrativo",
      "operations": "Operaciones"
    },
    "departments": {
      "none": "Ninguno",
      "administration": "Administración",
      "production": "Producción"
    },
    "positions": {
      "none": "Ninguno",
      "generalManager": "Gerente General",
      "administrativeAssistant": "Asistente Administrativo",
      "receptionist": "Recepcionista",
      "operationsSupervisor": "Supervisor de Operaciones",
      "extruderOperator": "Operador de Extrusora",
      "flexoOperator": "Operador Flexo",
      "cutOperator": "Operador de Corte",
      "operator": "Operador",
      "concierge": "Conserje"
    },
    "form": {
      "firstName": "Primer Nombre",
      "secondName": "Segundo Nombre",
      "firstLastName": "Primer Apellido",
      "secondLastName": "Segundo Apellido",
      "identity": "Cédula",
      "group": "Grupo",
      "department": "Departamento",
      "position": "Posición",
      "joinDate": "Fecha de Ingreso",
      "fpcId": "ID FPC",
      "salary": "Salario",
      "bankAccount": "Cuenta Bancaria",
      "bank": "Banco",
      "afp": "AFP",
      "tss": "TSS",
      "newEmployee": "Nuevo Empleado",
      "editEmployee": "Editar Empleado",
      "none": "Ninguno"
    }
  },
  "generalInfos": {
    "title": "Info General",
    "new": "Nuevo",
    "noData": "No se encontraron registros.",
    "reportDate": "Fecha del Reporte",
    "deleteTitle": "Eliminar Info General",
    "deleteText": "¿Estás seguro de que deseas eliminar {{name}}? Esta acción no se puede deshacer.",
    "duplicateTitle": "Duplicar Info General",
    "duplicateText": "¿Duplicar {{name}}? Se creará un nuevo registro con los mismos datos.",
    "duplicating": "Duplicando...",
    "form": {
      "editTitle": "Editar Info General",
      "newTitle": "Nueva Info General",
      "backTooltip": "Volver a Info General",
      "salary": "Salario",
      "dailySalary": "Salario Diario",
      "yearlySalary": "Salario Anual",
      "benefits": "Beneficios",
      "vacations": "Vacaciones",
      "vacationsBonus": "Bono Vacacional",
      "easterRoyalty": "Regalía Pascual",
      "firstBonus": "Primera Bonificación",
      "secondBonus": "Segunda Bonificación",
      "totalBonus": "Bonificación Total",
      "employeeRetentions": "Retenciones del Empleado",
      "employerPayments": "Pagos del Empleador",
      "removeRetention": "Eliminar retención",
      "addRetention": "Agregar Retención",
      "active": "Activo",
      "moveUp": "Subir",
      "moveDown": "Bajar",
      "amount": "Monto",
      "description": "Descripción",
      "yrs": "años",
      "noEmployeeSelected": "Sin empleado seleccionado",
      "noEntries": "Sin entradas aún. Haz clic en \"Agregar Entrada\" para comenzar.",
      "afpRetention": "AFP (2.87%)",
      "sfsRetention": "SFS (3.04%)",
      "contributionRetention": "Contribución (5.91%)",
      "afpPayment": "AFP (7.10%)",
      "sfsPayment": "SFS (7.09%)",
      "arlPayment": "ARL (1.10%)",
      "infotepPayment": "INFOTEP (1%)",
      "contributionPayment": "Contribución (16.29%)",
      "tssPayment": "TSS (22.20%)"
    }
  },
  "weeklyReports": {
    "title": "Reportes Semanales",
    "new": "Nuevo",
    "noData": "No se encontraron reportes.",
    "reportDate": "Fecha del Reporte",
    "deleteTitle": "Eliminar Reporte Semanal",
    "deleteText": "¿Estás seguro de que deseas eliminar {{name}}? Esta acción no se puede deshacer.",
    "duplicateTitle": "Duplicar Reporte Semanal",
    "duplicateText": "¿Duplicar {{name}}? Se creará un nuevo registro con los mismos datos.",
    "duplicating": "Duplicando...",
    "monthlyLog": "Log Mensual",
    "parseTimecard": "Importar Timecard",
    "generateExcel": "Generar Excel",
    "monthlyLogTitle": "Log Mensual",
    "form": {
      "editTitle": "Editar Reporte Semanal",
      "newTitle": "Nuevo Reporte Semanal",
      "backTooltip": "Volver a Reportes Semanales",
      "start": "Inicio",
      "end": "Fin",
      "holiday": "Feriado",
      "addEvent": "Agregar Evento",
      "addDay": "Agregar Día",
      "removeDay": "Eliminar día",
      "addDayNoRange": "Primero define una Fecha de Inicio y una Fecha de Fin válidas en el reporte.",
      "addDayRangeFull": "Todos los días entre la Fecha de Inicio y la Fecha de Fin ya están agregados.",
      "singleEventWarning": "Solo hay un evento de punch in/out registrado.",
      "missingTimesError": "Uno o más eventos tienen Inicio o Fin faltantes.",
      "invalidTimeRangeError": "Uno o más eventos terminan antes o al mismo tiempo que inician; cuentan como cero horas.",
      "noEmployee": "Sin empleado",
      "tabEmployees": "Empleados",
      "tabHours": "Horas",
      "tabDetails": "Detalles",
      "noEntries": "Sin entradas aún.",
      "noEvents": "Sin eventos.",
      "daily": "Diario",
      "hourly": "Por Hora",
      "extraHrs": "Hrs. Extra",
      "doubleHrs": "Hrs. Dobles",
      "nightHrs": "Hrs. Nocturnas",
      "punchIn": "Entrada",
      "punchOut": "Salida",
      "regularHrs": "Hrs. Regulares",
      "weekHours": "Horas Semana",
      "generating": "Generando…",
      "downloadExcel": "Descargar Excel"
    },
    "monthlyLogPage": {
      "backTooltip": "Volver a Reportes Semanales",
      "monthAndYear": "Mes y Año",
      "workedHrs": "Hrs. Trabajadas",
      "extraHrs": "Hrs. Extra",
      "doubleHrs": "Hrs. Dobles",
      "noData": "No se encontraron reportes para {{month}}"
    }
  },
  "payrolls": {
    "title": "Nóminas",
    "new": "Nueva",
    "noData": "No se encontraron nóminas.",
    "payrollDate": "Fecha",
    "deleteTitle": "Eliminar Nómina",
    "deleteText": "¿Estás seguro de que deseas eliminar {{name}}? Esta acción no se puede deshacer.",
    "duplicateTitle": "Duplicar Nómina",
    "duplicateText": "¿Duplicar {{name}}? Se creará un nuevo registro con los mismos datos.",
    "duplicating": "Duplicando...",
    "form": {
      "newTitle": "Nueva Nómina",
      "editTitle": "Editar Nómina",
      "loanRetentions": "Retenciones de Préstamo ({{count}})",
      "loanRetention": "Retención de Préstamo",
      "active": "Activo",
      "removeDay": "Eliminar día",
      "extraHoursSalary": "Salario Horas Extra",
      "customTotal": "Total personalizado",
      "daysCount": "{{count}} días",
      "noDays": "Sin días aún. Haz clic en \"Agregar Día\" para agregar uno.",
      "noEntries": "Sin entradas aún. Haz clic en \"Agregar Entrada\" para agregar una.",
      "salary": "Salario",
      "dailySalary": "Salario Diario",
      "otherDed": "Otras Ded.",
      "totalDed": "Total Ded.",
      "additional": "Adicional",
      "inactiveSuffix": " (INACTIVO)",
      "moveUp": "Subir",
      "moveDown": "Bajar"
    }
  },
  "extrusion": {
    "title": "Extrusión",
    "new": "Nueva Entrada",
    "noData": "No se encontraron entradas.",
    "ordersCount": "Órdenes",
    "deleteTitle": "Eliminar Extrusión",
    "deleteText": "¿Estás seguro de que deseas eliminar {{code}}? Esta acción no se puede deshacer.",
    "form": {
      "newTitle": "Nueva Extrusión",
      "editTitle": "Editar Extrusión",
      "code": "Código",
      "codeRequired": "El código es obligatorio.",
      "date": "Fecha",
      "version": "Versión",
      "ordersSection": "Órdenes",
      "addOrders": "Agregar órdenes",
      "materialColor": "Color Material",
      "reference": "Referencia",
      "kilos": "Kgs.",
      "units": "Unidades",
      "entryDate": "Fecha Entrada",
      "noOrders": "No hay órdenes asignadas.",
      "picker": {
        "title": "Agregar órdenes",
        "search": "Buscar (código, cliente, proyecto, referencia)",
        "entryDate": "Mes de entrada",
        "status": "Estado",
        "paperColor": "Color Material",
        "allStatuses": "Todos los estados",
        "allColors": "Todos los colores",
        "selectedCount": "{{count}} seleccionada",
        "selectedCount_other": "{{count}} seleccionadas",
        "addCount": "Agregar {{count}}",
        "noResults": "No se encontraron órdenes.",
        "loadError": "Error al cargar órdenes.",
        "retry": "Reintentar"
      }
    }
  },
  "orders": {
    "title": "Órdenes",
    "new": "Nueva",
    "noData": "No se encontraron órdenes.",
    "code": "Código",
    "client": "Cliente",
    "project": "Proyecto",
    "inExport": "En Exportación",
    "openExport": "Abrir Exportación",
    "references": "Referencias",
    "product": "Producto",
    "color": "Color",
    "paperColor": {
      "white": "Blanco"
    },
    "progKgs": "Kgs. Prog.",
    "totalKgs": "Kgs. Total",
    "status": "Estado",
    "statuses": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "deleteTitle": "Eliminar Orden",
    "deleteText": "¿Estás seguro de que deseas eliminar la orden {{code}}? Esta acción no se puede deshacer.",
    "form": {
      "newOrder": "Nueva Orden",
      "clientInfo": "Info del Cliente",
      "code": "Código",
      "date": "Fecha",
      "entryDate": "Fecha de entrada",
      "client": "Cliente",
      "project": "Proyecto",
      "location": "Localidad",
      "city": "Ciudad",
      "status": "Estado",
      "addReference": "Agregar Referencia",
      "reference": "Referencia",
      "refName": "Nombre",
      "paper": "Papel",
      "width": "Ancho (cms)",
      "height": "Alto (cms)",
      "grammage": "Gramaje",
      "sides": "Caras",
      "bellows": "Fuelle",
      "generalInfo": "Info General",
      "weightPerRoll": "Peso/Rollo (Kgs)",
      "weightPerCore": "Peso/Núcleo (Kgs)",
      "requestedAmount": "Cantidad Solicitada",
      "wastePercent": "Desperdicio %",
      "refilePercent": "Refile %",
      "minThousandWeight": "Peso Millar Mín.",
      "maxThousandWeight": "Peso Millar Máx.",
      "programmedKgs": "Kgs. Programados",
      "waste": "Desperdicio",
      "refile": "Refile",
      "total": "Total",
      "rolls": "Rollos",
      "extrusion": "Extrusión",
      "extruderNo": "No. Extrusora",
      "mold": "Molde (mm)",
      "widthFormula": "Fórmula de Ancho",
      "widthCms": "Ancho (cms)",
      "bellowsCms": "Fuelle (cms)",
      "pigment": "Pigmento",
      "treatment": "Tratamiento",
      "treatmentType": "Tipo de Tratamiento",
      "minWidth": "Ancho Mín.",
      "maxWidth": "Ancho Máx.",
      "caliber": "Calibre",
      "minCaliber": "Calibre Mín.",
      "maxCaliber": "Calibre Máx.",
      "primaryMix": "Mezcla Primaria",
      "secondaryMix": "Mezcla Secundaria",
      "addTo": "Agregar a {{section}}",
      "item": "Ítem",
      "loadingItems": "(cargando…)",
      "itemsLoadError": "No se pudieron cargar los ítems desde ADM Cloud. Recarga la página.",
      "physicalCount": "Conteo Físico",
      "physicalCountsLoadError": "No se pudieron cargar los conteos físicos desde ADM Cloud. Recarga la página.",
      "createNewPhysicalCount": "Crear nueva toma física",
      "physicalCountRequiresMix": "Agrega al menos un ítem a una mezcla primero",
      "sealing": "Sellado",
      "sideBellows": "Fuelle Lateral (cms)",
      "bottomBellows": "Fuelle Inferior (cms)",
      "sideSeal": "Sello Lateral",
      "bottomSeal": "Sello Inferior",
      "doubleBottomSeal": "Sello Doble Fondo",
      "bottomCut": "Corte Inferior",
      "length": "Largo",
      "minLength": "Largo Mín.",
      "maxLength": "Largo Máx.",
      "packaging": "Empaque",
      "boxes": "Cajas",
      "amountPerPkg": "Cantidad / Paq.",
      "pkgsPerMasterCase": "Paq. / Caja Master",
      "amountPerMasterCase": "Cantidad / Caja Master",
      "masterCaseCount": "No. Cajas Master",
      "printing": "Impresión",
      "printerNo": "No. Impresora",
      "inksAmount": "No. de Tintas",
      "roller": "Rodillo",
      "mounting": "Montaje",
      "threaded": "Roscado",
      "rollsNo": "No. Rollos",
      "kgPerRoll": "Kg. por Rollo",
      "mtPerRoll": "Mt. por Rollo",
      "noInk": "Sin Tinta",
      "noRoller": "Sin rodillo",
      "noMounting": "Sin montaje",
      "noThreaded": "Sin roscado",
      "sideA": "Cara A",
      "sideB": "Cara B",
      "addInk": "Agregar Tinta",
      "comment": "Comentario",
      "none": "Ninguno",
      "back": "Atrás",
      "color": {
        "na": "N/A",
        "white": "Blanco",
        "kraft": "Kraft"
      },
      "ink": {
        "noInk": "Sin Tinta",
        "oneInk": "1 Tinta",
        "twoInks": "2 Tintas",
        "threeInks": "3 Tintas",
        "fourInks": "4 Tintas"
      }
    },
    "reports": {
      "title": "Reportes",
      "perClient": "Por Cliente",
      "perProduct": "Por Producto",
      "monthly": "Mensual",
      "monthAndYear": "Mes y Año",
      "clientHeader": "Cliente",
      "productHeader": "Producto",
      "ordersCount": "Órdenes",
      "paperColor": "Color",
      "progKgs": "Kgs. Prog.",
      "totalKgs": "Kgs. Total",
      "noOrders": "No hay órdenes para el mes seleccionado.",
      "code": "Código",
      "client": "Cliente",
      "project": "Proyecto",
      "product": "Producto",
      "extrusion": "Extrusión",
      "new": "Nuevo"
    }
  },
  "export": {
    "new": "Nueva Exportación",
    "deleteTitle": "Eliminar Exportación",
    "deleteText": "¿Seguro que quieres eliminar la exportación \"{{name}}\"?",
    "entriesCount": "Entradas",
    "form": {
      "newTitle": "Nueva Exportación",
      "editTitle": "Editar Exportación",
      "name": "Nombre",
      "nameRequired": "El nombre es obligatorio.",
      "client": "Cliente",
      "updateDate": "Fecha de Actualización",
      "updateDateRequired": "La fecha de actualización es obligatoria.",
      "entriesSection": "Entradas",
      "addEntry": "Agregar Entrada",
      "addFromOrders": "Agregar desde Órdenes",
      "noEntries": "Sin entradas. Agrega una para comenzar.",
      "entry": {
        "opDate": "Fecha OP",
        "orderNumber": "Orden",
        "project": "Proyecto",
        "paperColor": "Color de Papel",
        "printingInks": "Colores Impresos",
        "kilograms": "Kilos",
        "artRequest": "Sol. Arte",
        "plateRequest": "Sol. Plancha",
        "plateApproval": "Aprob. Plancha",
        "exportNumber": "N° Exportación",
        "exitDate": "Fecha Salida",
        "urgent": "Urgente",
        "urgentLabel": "URGENTE",
        "unlinkConfirmTitle": "Desvincular Orden",
        "unlinkConfirmText": "La orden \"{{code}}\" dejará de estar vinculada a esta entrada. ¿Continuar?",
        "action": {
          "link": "Vincular Orden",
          "create": "Crear Orden",
          "unlink": "Desvincular",
          "openOrder": "Abrir Orden"
        }
      },
      "tristate": {
        "na": "N/A",
        "yes": "Sí",
        "no": "No"
      },
      "color": {
        "na": "N/A",
        "white": "Blanco",
        "kraft": "Kraft"
      }
    },
    "newOrderDialog": {
      "title": "Crear Orden",
      "orderCode": "Código de Orden",
      "orderDate": "Fecha de Orden",
      "orderEntryDate": "Fecha de Entrada",
      "client": "Cliente",
      "create": "Crear",
      "errorOrderCodeTaken": "El código de orden ya está en uso."
    }
  },
  "history": {
    "title": "Historial",
    "subtitle": "Todos los cambios del sistema, más recientes primero.",
    "openHistory": "Abrir historial",
    "openRecordHistory": "Abrir historial de este registro",
    "filters": {
      "module": "Módulo",
      "actor": "Usuario",
      "event": "Evento",
      "from": "Desde",
      "to": "Hasta",
      "all": "Todos",
      "clear": "Limpiar filtros"
    },
    "events": {
      "create": "Creó",
      "update": "Actualizó",
      "destroy": "Eliminó",
      "duplicate": "Duplicó"
    },
    "actor": {
      "system": "Sistema"
    },
    "diff": {
      "field": "Campo",
      "old": "Antes",
      "new": "Después",
      "empty": "—"
    },
    "group": {
      "summary": "{{count}} cambio en esta acción",
      "summary_other": "{{count}} cambios en esta acción"
    },
    "noEvents": "Sin historial aún.",
    "eventLine": "{{verb}} {{model}} #{{id}}",
    "fields": {
      "fpc_id": "FPC ID",
      "op_date": "Fecha OP",
      "name": "Nombre",
      "last_name": "Apellido",
      "join_date": "Fecha de Ingreso",
      "group": "Grupo",
      "department": "Departamento",
      "position": "Posición",
      "report_date": "Fecha del Reporte",
      "payroll_name": "Nombre de Nómina",
      "payroll_date": "Fecha de Nómina",
      "amount": "Monto",
      "description": "Descripción",
      "salary": "Salario",
      "daily_salary": "Salario Diario",
      "yearly_salary": "Salario Anual",
      "bonus": "Bono",
      "first_bonus": "Primer Bono",
      "second_bonus": "Segundo Bono",
      "vacations": "Vacaciones",
      "vacations_bonus": "Bono de Vacaciones",
      "easter_royalty": "Regalía de Pascua",
      "afp_retention": "Retención AFP",
      "sfs_retention": "Retención SFS",
      "contribution_retention": "Retención de Contribución",
      "afp_payment": "Pago AFP",
      "sfs_payment": "Pago SFS",
      "arl_payment": "Pago ARL",
      "infotep_payment": "Pago INFOTEP",
      "contribution_payment": "Pago de Contribución",
      "tss_payment": "Pago TSS",
      "other_deductions": "Otras Deducciones",
      "additional_value": "Valor Adicional",
      "is_custom": "Personalizado",
      "is_active": "Activo",
      "position": "Orden",
      "total_amount": "Monto Total",
      "entry_date": "Fecha de Entrada",
      "client_id": "ID del Cliente",
      "client_name": "Nombre del Cliente",
      "project_name": "Nombre del Proyecto",
      "location": "Ubicación",
      "city": "Ciudad",
      "order_code": "Código de Orden",
      "order_number": "Número de Orden",
      "order_date": "Fecha de Orden",
      "reference_number": "Número de Referencia",
      "color_name": "Color",
      "side": "Lado",
      "item_id": "ID del Item",
      "item_name": "Nombre del Item",
      "percentage_value": "Porcentaje",
      "total_value": "Total",
      "mix_type": "Tipo de Mezcla",
      "code": "Código",
      "version": "Versión",
      "date": "Fecha",
      "update_date": "Fecha de Actualización",
      "export_id": "ID Exportación",
      "order_id": "ID Orden",
      "kilograms": "Kilos",
      "paper_color": "Color de Papel",
      "printing_inks_amount": "Colores Impresos",
      "art_request": "Sol. Arte",
      "plate_request": "Sol. Plancha",
      "plate_approval": "Aprob. Plancha",
      "export_number": "N° Exportación",
      "exit_date": "Fecha Salida",
      "urgent": "Urgente"
    },
    "models": {
      "Employee": "Empleado",
      "GeneralInfo": "Información General",
      "GeneralInfoEntry": "Entrada de Información",
      "GeneralInfoEntryAdditionalRetention": "Retención Adicional",
      "Report": "Reporte Semanal",
      "ReportEntry": "Entrada del Reporte",
      "ReportEntryDay": "Día del Reporte",
      "ReportEntryDayEvent": "Evento del Día",
      "Payroll": "Nómina",
      "PayrollEntry": "Entrada de Nómina",
      "PayrollEntryDay": "Día de Nómina",
      "PayrollEntryDayAdditionalRetention": "Retención Adicional",
      "Order": "Orden",
      "OrderMixEntry": "Mezcla",
      "OrderPrintInk": "Tinta",
      "OrderReference": "Referencia",
      "Extrusion": "Extrusión",
      "ExtrusionOrder": "Orden de Extrusión",
      "Export": "Exportación",
      "ExportEntry": "Entrada de Exportación"
    }
  }
}
